import { CodatOidcConfig } from "@codat/client-cookie-manager";

import config from "config";

const oidcConfig: CodatOidcConfig = {
  authority: config.IDENTITY_SERVER_URL,
  clientId: "Portal",
  redirectUri: window.location.origin,
  scope:
    "openid UserManagement Portal PublicApi ConnectorHealth SyncHealthSite IntegrationsUI Products AssessApi FeaturesClientApi Developer ClientCredentialsUI BankingDataUploadApi ReportsGenerationApi",
  responseType: "id_token token",
  postLogoutRedirectUri: window.location.origin,
  autoSignIn: true,
};

export default oidcConfig;
